import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

class TextAreaValidator extends ValidatorComponent {

    renderValidatorComponent() {
        const { errorMessages, validators, label, isRemoveFg, hideLabel, requiredError, isRequired, infotext, withRequiredValidator, validatorListener, ...rest } = this.props;
        const { isValid } = this.state;
        return (
            <div className={(isRemoveFg ? "inline-input" : "form-group") + (isValid ? "" : " has-error") }>
                {hideLabel ? null : (<label>{label} {isRequired ? (<span className="text-danger">*</span>) : ''}</label>)}
                <textarea className ="form-control"
                    {...rest}
                    ref={(r) => { this.input = r; }}
                >
                </textarea>
                {infotext && !this.errorText() ? <small className="text-muted">{infotext}</small> : ""}
                {this.errorText()}
            </div>
        );
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <span className="help-block">
                {this.getErrorMessage()}
            </span>
        );
    }
}

export default TextAreaValidator;


// WEBPACK FOOTER //
// ./src/components/shared/textareavalidator.js